export const buttonStyle = {
  position: 'absolute',
  bottom: '10px',
  left: '50%',
  transform: 'translateX(-50%)',
  padding: '10px 20px',
  fontSize: '16px',
  backgroundColor: '#FFFFFFE5',
  color: 'black',
  border: 'none',
  cursor: 'pointer',
  borderRadius: ' 22.5px',
  width: '146px',
  height: '31px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}
export const canelStyle = {
  position: 'absolute',
  left: '93%',
  top: '10%',
  transform: 'translateX(-50%)',
  fontSize: '16px',
  backgroundColor: '#FFFFFFE5',
  color: 'black',
  border: 'none',
  cursor: 'pointer',
  borderRadius: ' 50%',
  width: '24px',
  height: '24px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
}
export const containerStyle = {
  position: 'relative',
  width: '100%',
  maxWidth: '1544px',
}
